import { FovErrorType, FovErrorOption, FovErrorExperience, FovPageType } from '@contentsquare/fov-constants';
export const errorOptions = [
    {
        value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.ANY },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.ANY_JS_ERRORS',
    },
    {
        value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.NAMED },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.NAMED_JS_ERRORS',
    },
    {
        value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.EXACT },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXACT_JS_ERRORS',
    },
    {
        value: { errorType: FovErrorType.JS, errorOption: FovErrorOption.GROUPED },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.GROUPED_JS_ERRORS',
    },
    {
        value: { errorType: FovErrorType.API, errorOption: FovErrorOption.ANY },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.ANY_API_ERRORS',
    },
    {
        value: { errorType: FovErrorType.API, errorOption: FovErrorOption.NAMED },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.NAMED_API_ERRORS',
    },
    {
        value: { errorType: FovErrorType.API, errorOption: FovErrorOption.EXACT },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXACT_API_ERRORS',
    },
    {
        value: { errorType: FovErrorType.API, errorOption: FovErrorOption.GROUPED },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.GROUPED_API_ERROR',
    },
    {
        value: { errorType: FovErrorType.CUSTOM, errorOption: FovErrorOption.ANY },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.ANY_CUSTOM_ERROR',
    },
    {
        value: { errorType: FovErrorType.CUSTOM, errorOption: FovErrorOption.NAMED },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.NAMED_CUSTOM_ERROR',
    },
    {
        value: { errorType: FovErrorType.CUSTOM, errorOption: FovErrorOption.EXACT },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXACT_CUSTOM_ERROR',
    },
    {
        value: { errorType: FovErrorType.CUSTOM, errorOption: FovErrorOption.GROUPED },
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.GROUPED_CUSTOM_ERROR',
    },
];
export const errorExperienceOptions = [
    {
        value: FovErrorExperience.EXPERIENCED,
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.EXPERIENCED',
    },
    {
        value: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.HAVE_NOT_EXPERIENCED',
    },
];
export const pageOptions = [
    {
        value: FovPageType.ANY,
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.SELECT_ANY_PAGE',
    },
    {
        value: FovPageType.PAGE,
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.SELECT_SPECIFIC_PAGE',
    },
    {
        value: FovPageType.URL,
        label: 'ANALYSIS_CONTEXT.ERROR_CONDITION.SELECT_SPECIFIC_URL',
    },
];
//# sourceMappingURL=error-condition-options-list.js.map